export enum CountryCode {
  PA = 'PA',
  MX = 'MX',
  GT = 'GT',
  HN = 'HN',
  SV = 'SV',
  CO = 'CO',
  PE = 'PE'
}
